import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNotificationQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', wf_adminFirst_afNotification?: { __typename?: 'WF_AdminFirst_AfNotificationConnection', edges?: Array<{ __typename?: 'WF_AdminFirst_AfNotificationEdge', node: { __typename?: 'WF_AdminFirst_AfNotification', id: string, templateMessage?: string | null, title?: string | null, actionButton?: string | null, buttonLinksTo?: string | null, buttonText?: string | null, createdTime?: any | null, creator?: string | null, imageFileName?: string | null, isRegular?: boolean | null, market?: string | null, afNotificationServiceTypeId?: string | null, scheduleTime?: any | null, excelFileName?: string | null, isTestNotification?: boolean | null, recipientSourceType?: string | null, afNotificationMemberLogs?: Array<{ __typename?: 'WF_AdminFirst_AfNotificationMemberLog', id: string, afNotificationId?: number | null, memberNumber?: string | null } | null> | null } }> | null } | null };


export const GetNotificationDocument = gql`
    query GetNotification($id: Int!) {
  wf_adminFirst_afNotification(filter: {afNotificationId: {eq: $id}}) {
    edges {
      node {
        id
        templateMessage
        title
        actionButton
        buttonLinksTo
        buttonText
        createdTime
        creator
        imageFileName
        isRegular
        market
        afNotificationServiceTypeId
        scheduleTime
        excelFileName @wf_blobSignature(name: "APP_PUSH_NOTIFICATION_EXCEL_FILES_SIGNATURE")
        isTestNotification
        recipientSourceType
        afNotificationMemberLogs {
          id
          afNotificationId
          memberNumber
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
      }
export function useGetNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
        }
export type GetNotificationQueryHookResult = ReturnType<typeof useGetNotificationQuery>;
export type GetNotificationLazyQueryHookResult = ReturnType<typeof useGetNotificationLazyQuery>;
export type GetNotificationQueryResult = Apollo.QueryResult<GetNotificationQuery, GetNotificationQueryVariables>;